import type { FC, ReactNode } from "react";

import Image from "@/assets/images/Image";
import { cn } from "@/lib/utils";

interface DefaultImageProps {
  classes?: string;
  children?: ReactNode;
}

const DefaultImage: FC<DefaultImageProps> = ({ classes, children }) => {
  return (
    <div
      className={cn(
        "flex items-center justify-center bg-[#F1F1F1] rounded-md shrink-0",
        classes
      )}
    >
      <Image />
      {children}
    </div>
  );
};

export default DefaultImage;
